import React, { useRef, useState } from 'react';

const PARTNERS = [
  { src: '/assets/partners/ESED-logo.jpg', alt: 'ESED' },
  { src: '/assets/partners/logo-oup.png', alt: 'Oxford University Press' },
  { src: '/assets/partners/psra_log.png', alt: 'PSRA' },
  { src: '/assets/partners/samsons_group_of_companies_logo.jpeg', alt: 'Samsons Group' },
  { src: '/assets/partners/308420674_179200721281853_1032441282494845476_n.jpg', alt: 'Partner 5' },
  { src: '/assets/partners/324512570_1222866758319090_7796075679994201241_n.jpg', alt: 'Partner 6' },
  { src: '/assets/partners/401092625_662728232721533_8201599142451261558_n.jpg', alt: 'Partner 7' },
];

const PartnersSlider = () => {
  const [paused, setPaused] = useState(false);
  const duplicated = [...PARTNERS, ...PARTNERS, ...PARTNERS];

  return (
    <section className="py-14 sm:py-16 bg-white border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8 text-center">
        <div className="section-badge mx-auto w-fit">
          <i className="fas fa-handshake" />
          Our Partners
        </div>
        <h2 className="font-poppins font-700 text-navy text-2xl sm:text-3xl">
          Trusted By Our Partners
        </h2>
        <p className="text-gray-400 text-sm font-inter mt-2">
          Working together to provide world-class education
        </p>
      </div>

      {/* Marquee track */}
      <div className="relative overflow-hidden">
        {/* Left fade */}
        <div className="absolute left-0 top-0 bottom-0 w-20 sm:w-32 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to right, white, transparent)' }} />
        {/* Right fade */}
        <div className="absolute right-0 top-0 bottom-0 w-20 sm:w-32 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to left, white, transparent)' }} />

        <div
          className="flex items-center gap-10 sm:gap-16"
          style={{
            animation: `marquee 35s linear infinite`,
            animationPlayState: paused ? 'paused' : 'running',
            width: 'max-content',
          }}
          onMouseEnter={() => setPaused(true)}
          onMouseLeave={() => setPaused(false)}
        >
          {duplicated.map((partner, i) => (
            <div
              key={i}
              className="flex-shrink-0 flex items-center justify-center w-28 sm:w-36 h-16 sm:h-20"
            >
              <img
                src={partner.src}
                alt={partner.alt}
                className="max-w-full max-h-full object-contain grayscale hover:grayscale-0 opacity-60 hover:opacity-100 transition-all duration-300 hover:scale-105"
                onError={(e) => { e.target.style.display = 'none'; }}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSlider;
